/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DirectoryGroupOption = {
  /**
   * Directory group identifier.
   */
  id: string;
  /**
   * Number of directory users in the group.
   */
  memberCount: number;
  /**
   * Directory group name.
   */
  name: string;
};

/** @internal */
export const DirectoryGroupOption$inboundSchema: z.ZodMiniType<
  DirectoryGroupOption,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    member_count: z.int(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "member_count": "memberCount",
    });
  }),
);

export function directoryGroupOptionFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryGroupOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryGroupOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryGroupOption' from JSON`,
  );
}
